import React from 'react'
import { RealEstateFeatures } from '../../../../../@types/types'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'
import { buildingTypeField } from '../../../../../components/pages/insertionPage/screens/commonFields/buildingType/BuildingType'
import { getDefaultClasses } from '../../../../../utils/style-utils'

export const apartmentRentEstateFeaturesList = [
  RealEstateFeatures.EQUIPPED_KITCHEN,
  RealEstateFeatures.BALCONY_TERRACE,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.SHARED_GARDEN,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.FLAT_SHARE_SUITABLE,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
  RealEstateFeatures.ELEVATOR,
]

export const apartmentRentEstateFeatures = estateFeatures(apartmentRentEstateFeaturesList)

export const createApartmentRentEstateFeaturesForWebView = (label: React.ReactNode, className: string) =>
  estateFeatures(apartmentRentEstateFeaturesList, label, className)

export const apartmentRentBuildingTypeOptions = [
  BuildingTypeOption.APARTMENT,
  BuildingTypeOption.ATTIC,
  BuildingTypeOption.BASEMENT,
  BuildingTypeOption.DUPLEX,
  BuildingTypeOption.ENTRESOL,
  BuildingTypeOption.GROUND_FLOOR,
  BuildingTypeOption.LOFT,
  BuildingTypeOption.PENTHOUSE,
  BuildingTypeOption.TERRACE,
  BuildingTypeOption.OTHER,
]

export const apartmentRentBuildingTypeField = buildingTypeField(
  'apartment',
  apartmentRentBuildingTypeOptions,
  getDefaultClasses('full')
)

export const getApartmentRentBuildingTypeOptions = () => [...apartmentRentBuildingTypeOptions]
